import urlcat from "urlcat";

import { axiosInstance, TENANT_API_URL } from "..";

export const SHIFT_PASSOCODES_URL = `${TENANT_API_URL}/staff/shift-passcodes`;

export const getAllShiftPasscodes = () =>
  axiosInstance.get(`${SHIFT_PASSOCODES_URL}`);

export const getShiftPasscode = (data: Record<string, number>) => {
  const url = urlcat(SHIFT_PASSOCODES_URL, data);

  return axiosInstance.get(url);
};

export const createShiftPasscode = (data: any) =>
  axiosInstance.post(`${SHIFT_PASSOCODES_URL}`, data);

export const updateShiftPasscode = (id: string, data: any) => {
  if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
    throw new Error("Invalid ID");
  }
  return axiosInstance.put(`${SHIFT_PASSOCODES_URL}/${id}`, data);
};

export const deleteShiftPasscode = (id: string) => {
  if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
    throw new Error("Invalid ID");
  }
  return axiosInstance.delete(`${SHIFT_PASSOCODES_URL}/${id}`);
};
